module.exports = __webpack_public_path__ + "static/media/logo.472bbbd4.png";